import { every, filter, map } from 'lodash';

export const CHANGE_SELECTED_COMPANIES = 'CHANGE_SELECTED_COMPANIES';
export function changeSelectedCompanies(companies) {
  return {
    type: CHANGE_SELECTED_COMPANIES,
    companies: companies
  };
}

export const CHANGE_SELECTED_PEOPLE = 'CHANGE_SELECTED_PEOPLE';
export function changeSelectedPeople(people) {
  return {
    type: CHANGE_SELECTED_PEOPLE,
    people: people
  };
}

export function resetSelectedCompanies() {
  return changeSelectedCompanies([]);
}

export function resetSelectedCompaniesOnCurrentPage() {
  return (dispatch, getState) => {
    const companies = getState().search.companies;
    const companyIds = map(companies, company => company.id);
    const selectedCompanyIds = getState().selectList.selectedCompanyIds || [];
    dispatch(changeSelectedCompanies(selectedCompanyIds.filter(id => !companyIds.includes(id))));
  };
}

export function toggleSelectCompany(company) {
  return (dispatch, getState) => {
    const selectedCompanyIds = getState().selectList.selectedCompanyIds || [];
    let newSelected;

    if (selectedCompanyIds.indexOf(company.id) > -1) {
      newSelected = filter(selectedCompanyIds, id => id !== company.id);
    } else {
      newSelected = [...selectedCompanyIds, company.id];
    }

    dispatch(changeSelectedCompanies(newSelected));
  };
}

export function toggleSelectAllCompanies() {
  return (dispatch, getState) => {
    const companyIds = getState().search.meta.companies.allIds;
    dispatch(changeSelectedCompanies(companyIds));
  };
}

export function toggleSelectAllCompaniesOnCurrentPage() {
  return (dispatch, getState) => {
    const companies = getState().search.companies;
    const companyIds = map(companies, company => company.id);
    const selectedCompanyIds = getState().selectList.selectedCompanyIds || [];

    const allSelected = every(
      companies, company => selectedCompanyIds.indexOf(company.id) > -1
    );

    if (allSelected) {
      dispatch(changeSelectedCompanies(selectedCompanyIds.filter(id => !companyIds.includes(id))));
    } else {
      dispatch(changeSelectedCompanies([...selectedCompanyIds, ...companyIds]));
    }
  };
}

export function resetSelectedPeople() {
  return changeSelectedPeople([]);
}

export function resetSelectedPeopleOnCurrentPage() {
  return (dispatch, getState) => {
    const people = getState().search.people;
    const peopleIds = map(people, person => person.id);
    const selectedPersonIds = getState().selectList.selectedPersonIds || [];
    dispatch(changeSelectedPeople(selectedPersonIds.filter(id => !peopleIds.includes(id))));
  };
}

export function toggleSelectPerson(person) {
  return (dispatch, getState) => {
    const selectedPersonIds = getState().selectList.selectedPersonIds || [];
    let newSelected;

    if (selectedPersonIds.indexOf(person.id) > -1) {
      newSelected = filter(selectedPersonIds, id => id !== person.id);
    } else {
      newSelected = [...selectedPersonIds, person.id];
    }

    dispatch(changeSelectedPeople(newSelected));
  };
}

export function toggleSelectAllPeople() {
  return (dispatch, getState) => {
    const peopleIds = getState().search.meta.people.allIds;
    dispatch(changeSelectedPeople(peopleIds));
  };
}

export function toggleSelectAllPeopleOnCurrentPage() {
  return (dispatch, getState) => {
    const people = getState().search.people;
    const peopleIds = map(people, person => person.id);
    const selectedPersonIds = getState().selectList.selectedPersonIds || [];

    const allSelected = every(
      people, person => selectedPersonIds.indexOf(person.id) > -1
    );

    if (allSelected) {
      dispatch(changeSelectedPeople(selectedPersonIds.filter(id => !peopleIds.includes(id))));
    } else {
      dispatch(changeSelectedPeople([...selectedPersonIds, ...peopleIds]));
    }
  };
}
